import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const watchShipStationApiSync = unaryStreamRpc({
  name: "watchShipStationApiSync",
  input: z.object({ workflowId: z.string() }),
  output: z.object({
    currentStep: z.string(),
    stepNumber: z.number(),
    totalSteps: z.number(),
    shipmentsSynced: z.number(),
    shipmentsTotal: z.number(),
    errors: z.array(z.string()),
    isRunning: z.boolean(),
  }),
});
